import React, { useState } from "react";
import { useAuth } from "../../../context/AuthProvider"; // Import useAuth
import styles from "./LoginForm.module.css";
import { Link } from "react-router-dom";
import { useTheme } from "../../../context/ThemeProvider";
import CustomGoogleButton from "../../Buttons/CustomGoogleButton/CustomGoogleButton";

interface LoginFormProps {
  onSuccess?: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({ onSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { login, loading } = useAuth();
  const { getUserTheme } = useTheme();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const isLogged = await login(email, password);
      if (!isLogged) {
        setErrorMessage("Invalid email or password");
        return;
      }
      if (isLogged) getUserTheme();
      setErrorMessage("");
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error("Login failed", error);
      setErrorMessage("Login failed. Please check your email and password.");
    }
  };

  return (
    <div>
      <h1 className={styles.heading}>Login</h1>

      <form onSubmit={handleSubmit}>
        <div className={`form-group ${styles.formGroup}`}>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            className={styles.inputBox}
            required
          />
        </div>
        <div className={`form-group ${styles.formGroup}`}>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            className={styles.inputBox}
            required
          />
        </div>
        {errorMessage && (
          <div className={styles.errorMessage}>{errorMessage}</div>
        )}
        <button type="submit" className={styles.loginButton}>
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>
      <CustomGoogleButton
        onError={(error: string) => {
          setErrorMessage(error);
        }}
      />
      <p className={styles.textColor}>
        By login and using Cardonize, you accepted the <a href="/cgu">CGU</a>{" "}
        and confidential polities
      </p>
      <div className="d-flex justify-content-around">
        <Link to="/forgot">Forgot Password?</Link>
        <Link to="/register">Register to Cardonize</Link>
      </div>
      {/* <GoogleLogin
          onSuccess={googleLoginSuccess} // Handle Google login success
          // onFailure={(error) => console.error("Google login failed", error)}
        /> */}
    </div>
  );
};

export default LoginForm;
